export default {"src":"/_next/static/media/like.48ed4279.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};